import { Root as Accordion, Item } from '@radix-ui/react-accordion';

import { IppicaHeaderInfoAccordionContent } from './ippicaHeaderInfoAccordionContent';
import { IppicaHeaderInfoAccordionTrigger } from './ippicaHeaderInfoAccordionTrigger';
import styles from './IppicaHeaderInfoAccordion.module.scss';

export type IppicaHeaderInfoAccordionProps = {
  hasMarginRight?: boolean;
};

export const IppicaHeaderInfoAccordion = ({ hasMarginRight }: IppicaHeaderInfoAccordionProps) => {
  return (
    <Accordion type="single" collapsible asChild>
      <Item className={`${styles.item} ${hasMarginRight ? styles.withMarginRight : ''}`} value="item-1">
        <IppicaHeaderInfoAccordionTrigger />
        <IppicaHeaderInfoAccordionContent />
      </Item>
    </Accordion>
  );
};
